import {APIEndpoint, Metric, PROCESS_NAME} from "../../common/constants";
import {getAPIGatewayRequest, getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import Moment from 'moment';
import { publishCount } from "../../../MetricUtility";



export async function getRunningBalanceDetails(params) {

    const {date, compEmployeeId} = params;

    let startTime = 0;
    let endTime = Moment(date).add(1, 'day').startOf('day').valueOf();

    let driverInfo = {employeeId: compEmployeeId}

    let requestParams = {
        dateRange: {
            startTime,
            endTime
        },
        driverInfo: driverInfo
    }
    let apiResponse = {}

    try {
        let apiGatewayRequest = getAPIGatewayRequest(APIEndpoint.RUNNING_BALANCE_DETAILS, requestParams, "POST");
        await getAPIGatewayDataFromParent(apiGatewayRequest).then(result => {
            if (result.status === 200) {
                apiResponse.employeeDebriefDetailList = result.data.employeeDebriefDetailList;
                apiResponse.runningBalance = result.data.runningBalance;
                apiResponse.hasError = false;
                publishCount(PROCESS_NAME, Metric.GetRunningBalanceDetails);
            } else {
                apiResponse.hasError = true;
            }
        });
    } catch (error) {
        console.log("error in calling getRunningBalanceDetails " , error)
        apiResponse.hasError = true;
    }

    if (apiResponse.hasError) {
        apiResponse.errorMessage = "Failed to fetch Running Balance Details";
        publishCount(PROCESS_NAME, Metric.GetRunningBalanceDetails_Failure);
        publishCount(PROCESS_NAME, Metric.GetRunningBalanceDetails);
    }

    return apiResponse;
}


// WEBPACK FOOTER //
// ./src/component/driverReconciliation/network/runningBalanceDetailsAPI.js